export const selectLogin = state => state.auth;
export const selectIsLoggedIn = state => !!selectLogin(state).token;
export const selectAuthToken = state => selectLogin(state).token;
export const selectAuthRole = state => selectLogin(state).role;
export const selectAuthStatus = state => selectLogin(state).status;
export const selectAuthSystem = state => selectLogin(state).system;
export const selectAuthId = state => selectLogin(state).id;
export const selectAuthDistributorId = state =>
  selectLogin(state).distributorId;
